import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { push } from 'react-router-redux';

import ForgotForm from '../components/ForgotForm/ForgotForm.js'
import Button from '../components/Button/Button.js'
import Header from '../components/Header/Header.js'
import Footer from '../components/Footer/Footer.js'


class Forgot extends Component {

  constructor(props){
    super(props);
  }

  componentWillMount(){
    const { dispatch, user } = this.props;
    
    if(user.isLoggedIn){
      dispatch(push('/'));
    } 
  }

  componentDidMount(){
    window.document.title = "Forgot Password - Pattycake";
  }


  render(){

    const { user } = this.props;

    return <div className="body-stretch">
      <Header transparent={true}/>
      <div className="stretched">
        <div className="container">
          <div className="row justify-content-center row-mega-padded">
            <div className="col-md-4">
              <h1 className="text-center">
                Don't worry.
              </h1>
              <p className="lead text-center p-push-down">We're forgetful too.</p>
              <ForgotForm/>
            </div>
          </div>
        </div>
      </div>
      <Footer/>
    </div>
  }
}

const mapStateToProps = (state) => {
  const { user } = state;

  return {
    user
  }
}

export default connect(mapStateToProps)(Forgot);


// import React, { Component } from 'react'
// import { connect } from 'react-redux'
// import PropTypes from 'prop-types'
// import { Link } from 'react-router-dom'

// import ForgotForm from '../components/ForgotForm/ForgotForm.js'
// import Button from '../components/Button/Button.js'

// class Forgot extends Component {

//   constructor(props){
//     super(props);
//   }

//   componentDidMount(){
//     window.document.title = "Forgot - Pattycake";
//   }


//   render(){
//      return <div className="screen-height-container">
//       <div className="shc-content-split">
//         <div className="shc-content-small shc-secondary flex-center-column" style={{padding: 40}}>
//           <img src="resources/favicon-96x96.png"/>
//           <br/>
//           <h1 className="text-center">
//             Don't worry!
//           </h1>
//           <p className="lead">We're forgetful sometimes too.</p>
//         </div>

//         <div className="shc-content-large shc-gs10 flex-center-column">
//           <span className="shc-top-left-button">
//             <Button 
//               size="medium" 
//               color="transparent"
//               display={<i className="fal fa-arrow-left"/>} 
//               onClick={()=>{this.props.history.goBack()}}
//               />
//           </span>
//           <ForgotForm/>
//         </div>
//       </div>
//     </div>
//   }
// }

// const mapStateToProps = (state) => {
//   const { 
   
//     //...
//   } = state;

//   return {
   
//     //...
//   }
// }

// export default connect(mapStateToProps)(Forgot);


// WEBPACK FOOTER //
// ./src/routes/Forgot.js